<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'name', validatorRules.name]" placeholder="请输入名称"></a-input>
        </a-form-item>
        <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['type', validatorRules.type]" :trigger-change="true" dictCode="wechat_type" placeholder="请选择类型"/>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'status', validatorRules.status]" placeholder="请输入状态"></a-input>
        </a-form-item>
        <a-form-item label="所属类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['sourceType', validatorRules.sourceType]" :trigger-change="true" dictCode="wechat_source_type" placeholder="请选择所属类型"/>
        </a-form-item>
        <a-form-item label="开发公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'certificationBody', validatorRules.certificationBody]" placeholder="请输入开发公司"></a-input>
        </a-form-item>
        <a-form-item label="运营部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-depart v-decorator="['departmentId', validatorRules.departmentId]" :trigger-change="true"/>
        </a-form-item>
        <a-form-item label="运营人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'operator', validatorRules.operator]" placeholder="请输入运营人"></a-input>
        </a-form-item>
        <a-form-item label="联系电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'managerPhone', validatorRules.managerPhone]" placeholder="请输入联系电话"></a-input>
        </a-form-item>
        <a-form-item label="管理员" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-user-by-dep v-decorator="['managerId', validatorRules.managerId]"
                                :trigger-change="true"
                                org-fields="username,realname,phone"
                                dest-fields="manager_id,manager_name,manager_phone"
                                code="user_msg"
                                multi="false"
                                @realname="realnamefun"/>
        </a-form-item>
        <a-form-item label="年审时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择年审时间" v-decorator="[ 'annualReviewTime', validatorRules.annualReviewTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
         <a-form-item label="粉丝量级" :labelCol="labelCol" :wrapperCol="wrapperCol">
           <a-input v-decorator="[ 'fanLevel', validatorRules.fanLevel]" placeholder="请输入粉丝量级"></a-input>
         </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'

  export default {
    name: "BusGisWechatAccountsManagementModal",
    components: {
      JDate,
      JSelectDepart,
      JDictSelectTag,
      JFormContainer,
      JSelectUserByDep,
    },
    data () {
      return {
        managerName:"",
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          name: {rules: [
            {required: true, message: '请输入名称!'},
          ]},
          type: {rules: [
          ]},
          status: {rules: [
          ]},
          sourceType: {rules: [
          ]},
          certificationBody: {rules: [
          ]},
          departmentId: {rules: [
          ]},
          operator: {rules: [
          ]},
          managerPhone: {rules: [
          ]},
          managerId: {rules: [
          ]},
          managerName: {rules: [
            ]},
          annualReviewTime: {rules: [
          ]},
          fanLevel: {rules: [
          ]},
        },
        url: {
          add: "/wechat.base/busGisWechatAccountsManagement/add",
          edit: "/wechat.base/busGisWechatAccountsManagement/edit",
        }
      }
    },
    created () {
    },
    methods: {
      realnamefun(val){
        this.managerName=val
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'name','type','status','sourceType','certificationBody','departmentId','operator','managerPhone','managerId','managerName','annualReviewTime','fanLevel'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            formData.managerName=this.managerName;
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','type','status','sourceType','certificationBody','departmentId','operator','managerPhone','managerId','managerName','annualReviewTime','fanLevel'))
      },
    }
  }
</script>